import {useEffect, useRef} from 'react';
import {
  FABRIC_GROUP_END,
  FABRIC_GROUP_START,
  TEXTBOX_SELECT_FIRST,
  UYO_SELECT_FIRST,
} from '../constants';

export const useCanvasEvents = ({
  canvasInstance,
  onChangeHandler,
  onSelectionEvent,
  onDeselectionEvent,
  handleBorderLimits,
  incrGroupCount,
  decrGroupCount,
  onUyoSelectFirst,
  onTextboxSelectFirst,
}) => {
  const mounted = useRef(false);
  useEffect(() => {
    if (!canvasInstance) return;

    const eventHandlers = {
      'object:modified': onChangeHandler,
      'object:added': onChangeHandler,
      'object:removed': onChangeHandler,
      'selection:updated': onSelectionEvent,
      'selection:created': onSelectionEvent,
      'selection:cleared': onDeselectionEvent,
      'mouse:up': handleBorderLimits,
      [FABRIC_GROUP_START]: incrGroupCount,
      [FABRIC_GROUP_END]: decrGroupCount,
      [UYO_SELECT_FIRST]: onUyoSelectFirst,
      [TEXTBOX_SELECT_FIRST]: onTextboxSelectFirst,
    };

    canvasInstance.on(eventHandlers);

    return () => {
      canvasInstance.off(eventHandlers);
    };
  }, [
    canvasInstance,
    onChangeHandler,
    onSelectionEvent,
    onDeselectionEvent,
    handleBorderLimits,
    incrGroupCount,
    decrGroupCount,
    onUyoSelectFirst,
    onTextboxSelectFirst,
  ]);

  useEffect(() => {
    if (!canvasInstance || mounted.current) return;
    mounted.current = true;
    const activeObjects = canvasInstance.getActiveObjects();
    // If any objects are already selected on mount, we need to trigger the selection event manually
    if (activeObjects.length) onSelectionEvent({selected: activeObjects});
  }, [canvasInstance, onSelectionEvent]);
};
